import { useSeoMeta } from "@unhead/react";
import { Suspense } from "react";
import EtherealScene from "@/components/scenes/EtherealScene";
import { ProjectNavigation } from "@/components/site/ProjectNavigation";

const EtherealThreadsPage = () => {
  useSeoMeta({
    title: "Let's FCK!",
    description: "",
  });

  return (
    <div>
      <div className="relative h-screen">
        <Suspense fallback={null}>
          <EtherealScene />
        </Suspense>
      </div>
      <ProjectNavigation href="/portfolio/quantum-leap" />
    </div>
  );
};

export default EtherealThreadsPage;
